module.exports = __webpack_public_path__ + "assets/img/dc33-ki.svg";